/* ═══════════════════════════════════════════════════════════
   BUTTON-TILT.JS — PALS
   Tilt 3D suave para botones neumórficos.
   - Solo corre si <body class="btn-tilt"> (setting button_tilt ON
     y button_style != mafer; lo decide theme.liquid).
   - Solo escritorio con mouse: (hover:hover) and (pointer:fine).
     En móvil/touch NO aplica (queda el press neumórfico).
   - Respeta prefers-reduced-motion.
   - Delegado en document → funciona con contenido dinámico (carrito).
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (!document.body || !document.body.classList.contains('btn-tilt')) return;
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Misma familia de botones neumórficos (no tarjetas grandes, no nav__cta).
  var SEL = [
    '.btn', '.btn-primary', '.btn-secondary', '.cart__checkout',
    '.shopify-payment-button__button--unbranded', '.variant-picker__option',
    '.filter-btn', '.coll-chip', '.coll-cta__btn',
    '.search-results__submit', '.category-link', '.product-card__quick-add'
  ].join(',');

  var MAX = 6;        // grados máximos de inclinación (suave)
  var active = null;

  function reset(el) {
    if (el) el.style.transform = '';
  }

  document.addEventListener('pointermove', function (e) {
    var el = e.target.closest ? e.target.closest(SEL) : null;
    if (!el) { if (active) { reset(active); active = null; } return; }
    if (active && active !== el) reset(active);
    active = el;

    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var px = (e.clientX - r.left) / r.width;    // 0..1
    var py = (e.clientY - r.top) / r.height;    // 0..1
    var ry = (px - 0.5) * 2 * MAX;              // rotateY (izq/der)
    var rx = -(py - 0.5) * 2 * MAX;             // rotateX (arriba/abajo)
    el.style.transform = 'perspective(600px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
  }, { passive: true });

  // Salida de la ventana / cambio de target sin pasar por otro botón.
  document.addEventListener('pointerout', function (e) {
    if (active && (!e.relatedTarget || !(e.relatedTarget.closest && e.relatedTarget.closest(SEL)))) {
      reset(active);
      active = null;
    }
  }, { passive: true });
})();
